import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { COLORS_ADMIN_PAGE } from '../../conf/constants';
import { ORDERS_TABLE_CONSTANTS } from '../constants/ordersTable';

interface OrdersPaginationProps {
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
}

const OrdersPagination: React.FC<OrdersPaginationProps> = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
}) => {
  if (totalItems === 0) return null;

  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 2,
        borderTop: `1px solid ${COLORS_ADMIN_PAGE.BORDER}`,
        bgcolor: COLORS_ADMIN_PAGE.WHITE,
        height: ORDERS_TABLE_CONSTANTS.PAGINATION_HEIGHT,
        boxSizing: 'border-box',
        flexShrink: 0
      }}
    >
      <Typography variant="body2" color="textSecondary">
        {ORDERS_TABLE_CONSTANTS.SHOWING_TEXT} {startItem} {ORDERS_TABLE_CONSTANTS.TO_TEXT} {endItem} {ORDERS_TABLE_CONSTANTS.OF_TEXT} {totalItems} {ORDERS_TABLE_CONSTANTS.ORDERS_TEXT}
      </Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <KeyboardArrowLeft />
        </Button>
        
        <Typography variant="body2" sx={{ mx: 2 }}>
          {currentPage} {ORDERS_TABLE_CONSTANTS.OF_TEXT} {totalPages}
        </Typography>
        
        <Button
          variant="outlined"
          size="small"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <KeyboardArrowRight />
        </Button>
      </Box>
    </Box>
  );
};

export default OrdersPagination;